module.exports = __webpack_public_path__ + "img/sellCard-avatar.b338e1dd.jpeg";